import { useSearchParams } from 'react-router-dom';
import useDomain from '@/hooks/useDomain';
import { buildBacklinkUrl } from './backlinkRoutes';

/** Path-scoped link helper for overview "more" footers. */
export const useBacklinkSectionHref = (
  routeTo: string,
  extraParams?: Record<string, string | number | boolean | null | undefined>
) => {
  const { domain_slug, domain } = useDomain();
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());
  if (extraParams) {
    Object.entries(extraParams).forEach(([k, v]) => {
      if (v != null && v !== '') params.set(k, String(v));
    });
  }
  return buildBacklinkUrl(routeTo, domain_slug, domain, params);
};
